import { createContext, useContext, useState } from 'react'

const eanContext = createContext([])
const eanUpdateContext = createContext()

export function useEan() {
  return useContext(eanContext)
}
export function useEanUpdate() {
  return useContext(eanUpdateContext)
}

export function EanProvider({ children }) {
  const [eans, setEan] = useState([])

  const updateEan = (array) => {
    setEan(array)
  }

  return (
    <eanContext.Provider value={eans}>
      <eanUpdateContext.Provider value={updateEan}>
        {children}
      </eanUpdateContext.Provider>
    </eanContext.Provider>
  )
}
